import productFilters from './modules/filters';

window.addEventListener('DOMContentLoaded', () => {
    productFilters();
});

window.addEventListener('recalcMobileFilterHeights', () => {
    $( '.modal_filters .accordion-item .filter-variants').each( function() {                
        const buttonMargin = 9;
        const selectedFilterButtons = $(this).find('.btn-dark');
        const defaultFilterHeight = 85;
        const buttonHeight = $(this).find('.btn').outerHeight();
        let hasActiveHeight = defaultFilterHeight;

        if( selectedFilterButtons.length > 0 ) {            
            const lastActiveButtonOffset = selectedFilterButtons.last().position().top;
            if( lastActiveButtonOffset + buttonMargin > defaultFilterHeight ) {
                hasActiveHeight = lastActiveButtonOffset + buttonMargin + buttonHeight;
            }
        }

        $(this).css( 'max-height', Math.max( defaultFilterHeight, hasActiveHeight ) + 'px' );
    });
});